module.exports = __webpack_public_path__ + "static/media/flat_grey.23c03b45.svg";